import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';
import { defineMessages, useIntl } from 'react-intl';

import styles from '../styles.module.css';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { Loader } from 'semantic-ui-react';

interface QubicaBaseFolderMapProps {
  qubicaBases: {
    name: string;
    lat: number;
    lng: number;
    link: string;
    base_type: string;
  }[];
  basesLoading?: boolean;
}

var stylesArray = [
  {
    featureType: 'administrative',
    elementType: 'all',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'simplified',
      },
      {
        color: '#fcfcfc',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'simplified',
      },
      {
        color: '#fcfcfc',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'simplified',
      },
      {
        color: '#dddddd',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'simplified',
      },
      {
        color: '#dddddd',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'simplified',
      },
      {
        color: '#eeeeee',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'simplified',
      },
      {
        color: '#dddddd',
      },
    ],
  },
];

const mapOptions = {
  defaultZoom: 3,
  minZoom: 2,
  defaultCenter: { lat: 44.811314, lng: 11.598848 },
  streetViewControl: false,
  zoomControl: true,
  mapTypeControl: false,
};

const QubicaBaseFolderMap = (props: QubicaBaseFolderMapProps) => {
  const intl = useIntl();
  const API_KEY = 'AIzaSyDQyYv_Rv0Smp2pupR1y2pIaaD_aAVoFAw';

  const handleMarkerLink = (baseLink: string) => {
    window.location.href = baseLink;
  };

  const { qubicaBases, basesLoading } = props;

  return (
    <APIProvider apiKey={API_KEY}>
      <Map styles={stylesArray} {...mapOptions}>
        {!basesLoading ? (
          qubicaBases.map((base) => (
            <UniversalLink
              href={base.link}
              key={base.link}
              openLinkInNewTab={true}
            >
              <Marker
                position={{ lat: base.lat, lng: base.lng }}
                clickable={true}
                onClick={() => handleMarkerLink(base.link)}
                icon={`/mapMarkers/${base.base_type}.png`}
              />
            </UniversalLink>
          ))
        ) : (
          <div className={styles.loadingMessageContainer}>
            <Loader active />
          </div>
        )}
      </Map>
    </APIProvider>
  );
};

export default QubicaBaseFolderMap;

const messages = defineMessages({
  loading_message: { id: 'loading_message', defaultMessage: 'Loading...' },
});
